<template>
    <div class="bg-primary-bg dark:bg-gray-800 p-6 rounded-xl shadow overflow-x-auto">
        <h2 class="text-lg font-medium text-gray-800 dark:text-white mb-4">Son Teslimatlar</h2>
        <table class="w-full text-sm text-left text-primary-text dark:text-gray-300 ">
            <thead class="text-gray-500 border-b dark:border-gray-600">
                <tr>
                    <th class="py-2">Şirket Adı</th>
                    <th>Teslimat Tarihi</th>
                    <th>Ürünler</th>
                    <th>Miktar</th>
                    <th>Plaka</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="isLoading">
                    <td colspan="5" class="py-4 text-center">
                        <div class="flex justify-center items-center">
                            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-primary-500"></div>
                            <span class="ml-2">Yükleniyor...</span>
                        </div>
                    </td>
                </tr>
                <tr v-else-if="deliveries.length === 0">
                    <td colspan="5" class="py-4 text-center text-gray-500 dark:text-gray-400">
                        Gösterilecek teslimat bulunamadı.
                    </td>
                </tr>
                <tr v-else v-for="delivery in deliveries" :key="delivery.id" class="border-b dark:border-gray-600">
                    <td class="py-2">{{ delivery.dealerName }}</td>
                    <td>{{ delivery.date }}</td>
                    <td>
                        <span class="px-2 py-1 text-gray-800 dark:text-gray-300 truncate whitespace-nowrap">
                            {{ delivery.products }}
                        </span>
                    </td>
                    <td>{{ formatTonnage(delivery.tonnage) }}</td>
                    <td>{{ delivery.plate }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { getApi } from '@/services/api'

export default {
  name: 'OrderTable',
  data() {
    return {
      deliveries: [],
      isLoading: false,
    }
  },
  async mounted() {
    await this.fetchDeliveries();
  },
  methods: {
        
//     formatNumber(value) {
//   if (value === null || value === undefined) return '0,00';
//   const parts = parseFloat(value).toFixed(2).split('.');
//   const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
//   const decimalPart = parts[1];
//   return `${integerPart},${decimalPart}`;
// },

 formatTonnage (value) {
  if (value === null || value === undefined) return '0';
  const integerPart = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return integerPart;
},


    async fetchDeliveries() {
      this.isLoading = true;
      try {
        const response = await getApi(`/deliveries/approved/10/0`);
        const sorted = response.deliveries.sort(
          (a, b) => new Date(b.delivery_time) - new Date(a.delivery_time)
        );
        this.deliveries = sorted.map(delivery => ({
          id: delivery.delivery_id,
          dealerName: delivery.dealer?.dealer_name || 'Bilinmeyen Bayi',
          date: new Date(delivery.delivery_time).toLocaleDateString('tr-TR'),
          products: delivery.product?.name || 'Ürün Bilgisi Yok',
          tonnage: delivery.delivery_tonnage,
          plate: delivery.delivery_plate || '-',
        }));
      } catch (err) {
        console.error('Teslimat verileri alınırken hata:', err);
        this.deliveries = [];
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>